var map = {
	"./Diana-27.jpeg": 330,
	"./Diana.jpeg": 2278,
	"./Luca-6.jpeg": 8395,
	"./insta19.jpeg": 3516,
	"./insta3.jpeg": 1051,
	"./insta8.jpeg": 470,
	"./kindle-10.jpeg": 8684,
	"./kindle-15.jpeg": 3535,
	"./lavanda-15-min.jpeg": 7830,
	"./lavanda-16-min.jpeg": 4547,
	"./lavanda-42-min.jpeg": 2558,
	"./lavanda-53-min.jpeg": 796,
	"./lifestyle1.jpeg": 133,
	"./lifestyle10.jpeg": 379,
	"./lifestyle11.jpeg": 9220,
	"./lifestyle12.jpeg": 5157,
	"./lifestyle13.jpeg": 2670,
	"./lifestyle14.jpeg": 2503,
	"./lifestyle15.jpeg": 6720,
	"./lifestyle16.jpeg": 4065,
	"./lifestyle17.jpeg": 570,
	"./lifestyle18.jpeg": 4195,
	"./lifestyle19.jpeg": 2540,
	"./lifestyle2.jpeg": 9860,
	"./lifestyle20.jpeg": 4380,
	"./lifestyle21.jpeg": 2115,
	"./lifestyle22.jpeg": 9638,
	"./lifestyle3.jpeg": 2603,
	"./lifestyle4.jpeg": 2586,
	"./lifestyle5.jpeg": 9985,
	"./lifestyle6.jpeg": 2320,
	"./lifestyle7.jpeg": 3143,
	"./lifestyle8.jpeg": 502,
	"./lifestyle9.jpeg": 5517,
	"./maria10.jpeg": 6930,
	"./maria11.jpeg": 2777,
	"./maria12.jpeg": 3112,
	"./maria13.jpeg": 527,
	"./maria14.jpeg": 6390,
	"./maria15.jpeg": 3261,
	"./maria2.jpeg": 5459,
	"./maria3.jpeg": 156,
	"./maria4.jpeg": 1177,
	"./maria5.jpeg": 9602,
	"./maria6.jpeg": 6751,
	"./maria7.jpeg": 2616,
	"./maria8.jpeg": 2773,
	"./maria9.jpeg": 3934,
	"./new1.jpeg": 7158,
	"./new2.jpeg": 5171,
	"./new3.jpeg": 4588,
	"./new4.jpeg": 5849,
	"./new5.jpeg": 9170,
	"./olga14.jpeg": 4285,
	"./olga4.jpeg": 8556,
	"./revuele.jpeg": 4513,
	"./speak1.jpeg": 5110,
	"./speak2.jpeg": 7587,
	"./studio1.jpeg": 9284,
	"./studio10.jpeg": 3420,
	"./studio2.jpeg": 5221,
	"./studio3.jpeg": 6382,
	"./studio4.jpeg": 2567,
	"./studio5.jpeg": 6784,
	"./studio6.jpeg": 4129,
	"./studio7.jpeg": 634,
	"./studio8.jpeg": 7907,
	"./studio9.jpeg": 2604,
	"./top.jpeg": 9266,
	"./valentines1.jpeg": 8987,
	"./valentines2.jpeg": 5758,
	"./valentines3.jpeg": 6517,
	"./valentines4.jpeg": 8704,
	"./valentines5.jpeg": 9527,
	"./valentines6.jpeg": 8970,
	"./valentines7.jpeg": 6369,
	"./zarea.jpeg": 2542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3400;